export const parseName = (first_name = '', last_name = '') => {
  first_name = first_name?.split(' ')[0]
  last_name = last_name?.split(' ')[0]
  return `${first_name} ${last_name}`.trim()
}

export default parseName
